// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ceb0c0c7","453":"f4c6038f","455":"e3eb4d34","977":"22b02e9d"}[chunkId] + ".chunk.js";
};